import { PartnerType } from 'vopay';

/** The partner types that onboard partners of their own; the create-partner route enforces the same list. */
const PARTNER_CREATOR_TYPES: PartnerType[] = ['Technology', 'VAR', 'Referral'];

/**
 * Whether the session may create partner accounts: the Partners module's gate (an Admin with partner
 * creation) and a partner type that onboards partners — Inside Sales does not. One rule for the
 * Partner Accounts page's Add Partner, the Overview's Add Entity and the chart cards' + Partner.
 */
export default function canCreatePartners({
  isRoleAdmin,
  isPartnerCreationEnabled,
  partnerType,
}: {
  isRoleAdmin: boolean;
  isPartnerCreationEnabled: boolean;
  partnerType: PartnerType | '';
}) {
  return isRoleAdmin && isPartnerCreationEnabled && partnerType !== '' && PARTNER_CREATOR_TYPES.includes(partnerType);
}
